import { CheckIcon } from '@heroicons/react/20/solid'

const includedFeatures = [
  '5 questionnaires customisés',
  '250 employés',
  'Réponses illimitées',
  'Rapports en direct',
]

export default function PricingBox() {
  return (
    <div className="bg-white rounded-3xl">
      <div className="max-w-full w-full ">
        <div className="mt-8  max-w-2xl rounded-3xl ring-1 ring-gray-200  lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-2xl font-bold tracking-tight text-gray-900">Abonnement "Business"</h3>
            <p className="mt-6 text-base leading-7 text-gray-600">
              Lorem ipsum dolor sit amet consect etur adipisicing elit. Itaque amet indis perferendis blanditiis
              repellendus etur quidem assumenda.
            </p>
            <div className="mt-10 flex items-center gap-x-4">
              <h4 className="flex-none text-sm font-semibold leading-6 text-indigo-600">Ce qui est inclus</h4>
              <div className="h-px flex-auto bg-gray-100" />
            </div>
            <ul
              role="list"
              className="mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-gray-600 sm:grid-cols-2 sm:gap-6"
            >
              {includedFeatures.map((feature) => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon className="h-6 w-5 flex-none text-indigo-600" aria-hidden="true" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md w-1/2 h-fit">
            <div className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-20">
              <div className="mx-auto max-w-xs px-8">
                <p className="text-base font-semibold text-gray-600">Facturation mensuelle</p>
                <p className="mt-6 flex items-baseline justify-center gap-x-2">
                  <span className="text-5xl font-bold tracking-tight text-gray-900">149</span>
                  <span className="text-sm font-semibold leading-6 tracking-wide text-gray-600">€</span>
                </p>
                <a
                  href="#"
                  className="mt-10 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Gérer mon abonnement
                </a>
                <p className="mt-6 text-xs leading-5 text-gray-600">
                  Votre abonnement est géré par la plateforme Stripe. 
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
